import React, { useState, useContext, useEffect } from "react"
import Loader1 from "../../../interceptors/loader-interceptor"
import { JourneyContext } from "../../context/journeyContext"
import { SectionContext } from "../../context/sectionContext"
import { PageContext } from "../../context/pageContext"
import {
  fetchAllJourneyData,
  saveApplication,
  checkPaymentStatus,
  saveTransactionDetails,
  paymentTextDecrypt,
  getCamsPayManadateStatus
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  feetToCms,
  DataLayerIntegration
} from "../../services/helperFunctions"
import { TpaContext } from "../../context/tpaContext"
import { lineCapital, maskAlternateCharsInEmail, maskInFormat, wordCapital } from '../../../shared/functions';
import UnsuccessfulTransactionBasba from "../unsuccessful-transaction-basba"

export default function ReviewDetailsflexiEdge(props) {

  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [allJourneyData, setAllJourneyData] = useState()
  const [appointeeDetails, setAppointeeDetails] = useState({})
  const {tpaState,tpaStateSA} = useContext(TpaContext)
  const [showBasbaFailedPage,setShowBasbaFailedPage] = useState(false)

  useEffect(() => {
    let payload = {
      journeyId: journeyState.journeyId,
    }
    fetchAllJourneyData(payload)
      .then(res => {
        setAllJourneyData(res)
        let appointee = {}
        res?.nominees?.forEach((nominee, index) => {
          if (nominee?.appointee?.fullName) {
            appointee = nominee.appointee
          }
        })
        setAppointeeDetails(appointee)
      })
      .catch(err => {
        console.log(err)
      })
  }, [props.saveApplicationCounter])

  useEffect(() => {
    let payload = {
      journeyId: journeyState.journeyId,
    }
    getCamsPayManadateStatus(payload)
      .then(res => {
        console.info(res)
        setJourneyState(prev => {
          return {
            ...prev,
            basbaStatus : res?.data?.status
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  const handleSubmit = (ev) => {
    if (journeyState.basbaStatus === "Failed"){
      setShowBasbaFailedPage(true)
      return;
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    ev.preventDefault()
    const reviewHandleSubmitCall = () => {
      let lastPage;
      let lastSection;
      if (tpaState.skipPage && (tpaStateSA.skipPage || tpaStateSA.isSA === false)){
        lastPage = props.currentPageIndex + 1 // move to next page, skip tpa sections altogether
        lastSection = 0
      }else if (tpaState.skipPage && !tpaStateSA.skipPage){
        lastPage = props.currentPageIndex
        lastSection = props.currentSectionIndex + 2
      }else{
        lastPage = props.currentPageIndex
        lastSection = props.currentSectionIndex + 1
      }
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: lastPage,
          lastSection: lastSection,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }
      saveApplication(sendPayload).then(res => {
        if (tpaState.skipPage && (tpaStateSA.skipPage || tpaStateSA.isSA === false)){
          props.setCurrentPageIndex(prev => prev + 1)
          props.setCurrentSectionIndex(0)
        }else if (tpaState.skipPage && !tpaStateSA.skipPage){
          props.setCurrentSectionIndex(prev => prev + 2)
        }else{
          props.setCurrentSectionIndex(prev => prev + 1)
        }
        setJourneyState((prev) => {
          return ({
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
          })
        })
      }).catch(err => {
        console.log(err, "err in saveApplication")
      })
    }
    //handle-payment-fetch-status
    if ((allJourneyData?.transactionDetails?.paymentStatus === 'Failed' || allJourneyData?.transactionDetails?.paymentStatus === 'Pending') && allJourneyData?.paymentStep == 'L') {
      let srcTraceId = allJourneyData?.transactionDetails?.srcTraceId;
      let lastTransaction = allJourneyData?.transactionDetails
      checkPaymentStatus(srcTraceId).then((res_str) => {
        const payload = {
          "encryptedtext": res_str
        }
        paymentTextDecrypt(payload).then(res => {
          console.log(res, "paymentTextDecrypt")
          const paymentStatus = res.data.status
          lastTransaction.status = paymentStatus;
          let payloadForSaveTransaction = {
            journeyId: journeyState.journeyId,
            ...lastTransaction
          }
          console.log(payloadForSaveTransaction, "payloadForSaveTransaction")
          saveTransactionDetails(payloadForSaveTransaction).then((res) => {
            console.log(res, "saveTransactionDetails");
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus
            if (paymentStatus === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            }
            reviewHandleSubmitCall()
          })
        })
      }).catch((err) => {
        console.log("checkPaymentStatusFailed-at-reviewDetails")
      })
    } else {
      reviewHandleSubmitCall()
    }
  }
  // code of tab enter
  const handleEnterSubmit = (event) => {
    if (event?.key == 'Enter') {
      handleSubmit(event);
    }
  }

  const handleEdit = (ev) => {
    ev.preventDefault()
    console.log(pageState, sectionState, journeyState.journeyData)
    props.setCurrentSectionIndex(0)
    setSectionState(prev => {
      return {
        ...prev,
        sectionId: null,
        sectionData:{},
        sectionFirstPass: null
      }
    })

  }

  const emailId = allJourneyData
  ?.lifeAssuredDetails
  ?.communicationDetails
  ?.contactDetails
  ?.emailId;
  
  const maskedEmail = maskAlternateCharsInEmail(emailId)
  
  if (showBasbaFailedPage){
    return (<div>
      <UnsuccessfulTransactionBasba currentPageIndex={props.currentPageIndex}
        currentSectionIndex={props.currentSectionIndex}
        setCurrentSectionIndex={props.setCurrentSectionIndex}
        sections={props.sections}
        setCurrentPageIndex={props.setCurrentPageIndex}
        pageId={props.pageId} />
    </div>)
  }


  return (
    <>
      <Loader1 />
      <style>
        {`
                    @media(max-width:767px){
                        #checkboxG6-error{font-size: 13px !important; bottom:-15px !important;}
                    }
                    .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                      margin-left:-2px;
                    }
                    ::-ms-clear {
                      display: none;
                    }
                    span#checkboxG6-error {
                        font-size: 15px;
                    }
                    .d-none{
                        display: none;
                    }   
                    .br-0{
                        border-radius: 0px !important;
                     }
                `}
      </style>
      {/* body Section */}
      <div className="landing-page1-design">
        <div className="container">
          {allJourneyData &&
            <div className="row">
              <form action="" method="POST" id="biDetail">
                <div className="col-md-12">
                  <div className="iselect-box-design">
                    <div className="heading-design">
                      <div className="iselect-padding left-side-head ckyc-w">
                        <h1 className="iselect-heading">Review Details</h1>
                      </div>
                      <div className="app-quatation nri-mt-space hidden-desktop-screen">
                        <div className="application-design-number">
                          Application Number: {journeyState.applicationNo}
                        </div>
                      </div>
                    </div>
                    <div className="iselect-padding bi-summary">
                      <div className="auther-description">
                        <h3>Dear {lineCapital(allJourneyData?.lifeAssuredDetails?.title)} {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName)},</h3>
                        <p className="benefit-title">
                          Please review the below details before submitting your
                          proposal form.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="iselect-mg-bottom row">
                  <div className="col-lg-6 col-md-12">
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Personal Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color-grey">
                                <td> Name </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(allJourneyData?.lifeAssuredDetails?.fullName) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Gender </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "gender",
                                  allJourneyData.lifeAssuredDetails?.gender
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Date of Birth </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {maskInFormat(
                                  allJourneyData.lifeAssuredDetails?.dob * 1000
                                ) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td> Mobile Number </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo.slice(0,5) + "*****") || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Alternate Mobile Number </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.altMobileNo ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.altMobileNo.slice(0,5) + "*****" : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Email Address </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(maskedEmail || "NA")} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Proof of identity/age</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "PROOF_OF_ID",
                                  allJourneyData?.lifeAssuredDetails?.proofOfIdentity
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>PAN</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.panNumber ? `******${allJourneyData?.lifeAssuredDetails?.panNumber.slice(-4)?.toUpperCase()}` : "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>CKYC Number</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.ckycNumber ? allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.ckycNumber.slice(0,5) + "*****" : "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Marital Status</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup("maritalStatus", allJourneyData?.lifeAssuredDetails?.maritalStatus)) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Annual Income</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome.slice(0, 5) + "*****" : "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Educational Qualification</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                  "education",
                                  allJourneyData?.lifeAssuredDetails?.employmentDetails?.education
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Father name</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.lifeAssuredDetails?.fatherFirstName ? allJourneyData?.lifeAssuredDetails?.fatherFirstName : ""} ${allJourneyData?.lifeAssuredDetails?.fatherMiddleName ? allJourneyData?.lifeAssuredDetails?.fatherMiddleName : ""} ${allJourneyData?.lifeAssuredDetails?.fatherLastName ? allJourneyData?.lifeAssuredDetails?.fatherLastName : ""}`) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Mother name</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.lifeAssuredDetails?.motherFirstName ? allJourneyData?.lifeAssuredDetails?.motherFirstName : ""} ${allJourneyData?.lifeAssuredDetails?.motherMiddleName ? allJourneyData?.lifeAssuredDetails?.motherMiddleName : ""} ${allJourneyData?.lifeAssuredDetails?.motherLastName ? allJourneyData?.lifeAssuredDetails?.motherLastName : ""}`) || "NA"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Professional Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color-grey">
                                <td>Occupation </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "occupation",
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.occupation
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Exact nature of occuption </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "natureOfOccupation",
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.natureOfOccupation
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Nature of Duties </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "natureOfOccupation",
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.natureOfOccupation
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td> Nature of Industry of the Employer </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "natureOfIndustry",
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.employerIndustry
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Company Address</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.communicationDetails?.officeAddress?.address1 ? (`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.officeAddress?.address1 ?? ""} ${allJourneyData?.lifeAssuredDetails?.communicationDetails?.officeAddress?.address2 ?? ""} ${allJourneyData?.lifeAssuredDetails?.communicationDetails?.officeAddress?.areaTalukaTehsil ?? ""}`) : "NA"} </td>
                              </tr>
                              {
                                allJourneyData.lifeAssuredDetails?.employmentDetails?.occupation === "1"
                                  ? (<tr className="table-color">
                                    <td>Employer/Organisation</td>
                                    {
                                      (
                                        <td align="right" style={{ wordBreak: "break-all" }}>{(((
                                          allJourneyData?.lifeAssuredDetails?.employmentDetails?.otherEmployerName
                                        ))) || "NA"} </td>
                                      )
                                    }
                                  </tr>) : ("")
                              }
                              {
                                allJourneyData.lifeAssuredDetails?.employmentDetails?.occupation === "1" &&
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.employerName === "others"
                                  ? (<tr className="table-color">
                                    <td>Others/Company Name</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{((allJourneyData?.lifeAssuredDetails?.employmentDetails?.othersEmployerName)) || "NA"} </td>
                                  </tr>) : ("")
                              }
                              <tr className="table-color-grey">
                                <td>
                                  Is there any risk involved with your occupation?
                                  Eg. Working with boiler, explosives, chemicals
                                  etc.
                                </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.employmentDetails?.risksAssociated
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Are you a politically exposed person.</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.lifeStyleAndHabits?.laPoliticallyExposedPerson
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Have you ever been convicted or are you
                                  underinvestigation for any criminal charges
                                </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.haveConvicted
                                )) || "NA"} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Health & Lifestyle Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color-grey">
                                <td>Height (cms)</td>
                                <td align="right"> {allJourneyData?.lifeAssuredDetails?.personalDetails?.cms || feetToCms(allJourneyData?.lifeAssuredDetails?.personalDetails?.height, allJourneyData?.lifeAssuredDetails?.personalDetails?.inches) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Weight (kgs)</td>
                                <td align="right"> {allJourneyData?.lifeAssuredDetails?.personalDetails?.weight || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Has your weight altered more than 5 kgs in the
                                  last 1 year for reasons other than exercise?{" "}
                                </td>
                                <td align="right"> {(getValueFromLookup(
                                  "changesInLaWeight",
                                  allJourneyData.lifeAssuredDetails?.personalDetails?.changesInLaWeight
                                )) == "Na" ? "No" : (getValueFromLookup(
                                  "changesInLaWeight",
                                  allJourneyData.lifeAssuredDetails?.personalDetails?.changesInLaWeight
                                )) || "NA"}  </td>
                              </tr>
                              <tr className="table-color">
                                <td> Have you ever consumed Tobacco?</td>
                                <td align="right"> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.personalDetails?.smoking
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Have you ever consumed Alcohol?</td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.personalDetails?.alcohol
                                )) || "NA"}  </td>
                              </tr>
                              <tr className="table-color">
                                <td>Have you ever consumed any narcotics?</td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.personalDetails?.narcotics
                                )) || "NA"}  </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {allJourneyData.productDetails?.spouseLaDetails?.wishToSecure === "02" && (
                      <div>
                        {(allJourneyData.spouseDetails?.residentStatus === "Y" || allJourneyData?.spouseDetails?.questOccupation?.merMarineQues?.currentEmp === 'N') && (
                          <div className="col-md-12 pr pl">
                            <div className="table-responsive table-design">
                              <h2 className="headline-table">Joint Life NRI Questionnaire </h2>
                              <div className="table-bg">
                                <table className="table">
                                  <tbody>
                                    <tr className="table-color-grey">
                                      <td>
                                        Have you changed country in past 3 yrs?
                                      </td>
                                      <td align="right"> {lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.changeCountryPast
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>
                                        Do you have any former name?
                                      </td>
                                      <td align="right"> {lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.anyFormerName
                                      )) || "NA"}</td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                        Have you changed nationality?
                                      </td>
                                      <td align="right"> {lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.changedNationality
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>
                                        {" "}
                                        Do you earn any income in India?
                                      </td>
                                      <td align="right"> {lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.isEarnIncome
                                      )) || "NA"}</td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                        Is there any prosecution/legal proceeding initiated in the past or going on against you presently before any judicial forum/ authority in the country of your residence?
                                      </td>
                                      <td align="right">{lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.legalCase
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                        Name and address, phone no. of your physician in your country of residence?
                                      </td>
                                      <td align="right">{lineCapital(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.questNRI?.isNriDetailGiven
                                      )) || "NA"} </td>
                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}

                      </div>
                    )}

                    {allJourneyData?.nominees?.map((nominee, index) => {
                      return (
                        <div className="col-md-12 pr pl">
                          <div className="table-responsive table-design">
                            <h2 className="headline-table">Nominee {(allJourneyData?.nominees.length > 1) ? index + 1 : ""} Details</h2>
                            <div className="table-bg">
                              <table className="table">
                                <tbody>
                                  <tr className="table-color-grey">
                                    <td>Nominee's Full Name</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {`${nominee?.firstName}` || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>Date of Birth</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {getDateInFormat(
                                      nominee?.dob
                                    ) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>Nominee’s Relationship with you</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                      "nomineeRelationshipWithLA",
                                      nominee?.relationshipWithLa
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td> Gender</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                      "gender",
                                      nominee?.gender
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>Nominee's Contact Number</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{nominee?.contactDetails?.mobileNo || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td> Nominee’s Email</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {(lineCapital(nominee?.contactDetails?.emailId)) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>Pin code</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{nominee?.communicationDetails?.pinCode || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                     <td>Country</td>
                                  <td align="right">{nominee?.communicationDetails?.country ?
                                  lineCapital(getValueFromLookup(
                                    "country",
                                    nominee?.communicationDetails?.country
                                  )) : "NA"} </td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td> Nominee's Percentage</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {nominee?.percentage || "100%"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Residence Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color-grey">
                                <td> Current Country of Residence </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.lifeAssuredDetails?.communicationDetails?.currentAddress?.country
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Residential Status </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "residentStatus",
                                  allJourneyData.lifeAssuredDetails?.residentStatus
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Country of Birth </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.lifeAssuredDetails?.countryOfBirth
                                )) || "NA"} </td>
                              </tr>

                              <tr className="table-color-grey">
                                <td>Citizenship </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.lifeAssuredDetails?.citizenship
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Nationality </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.lifeAssuredDetails?.nationality
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Tax Residence country</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.lifeAssuredDetails?.communicationDetails?.additionalInfo?.taxResidencyCountry
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Current Residential Address</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.address1 ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.address1.slice(0, 5) + "******************"  : ""}`) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Pin code</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>State</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(lineCapital(getValueFromLookup(
                                  "state",
                                  allJourneyData.lifeAssuredDetails?.communicationDetails?.currentAddress?.state
                                ))) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>City</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityDistrict) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Address Proof Document</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                  "ADDRESS_PROOF_LOOKUP",
                                  allJourneyData?.lifeAssuredDetails?.communicationDetails?.addProofSubmitted?.addressProof
                                )) || "NA"} </td>
                              </tr>
                              {(allJourneyData?.lifeAssuredDetails?.communicationDetails?.sameAsCurrentAddress === "N") ?
                                <>
                                  <tr className="table-color-grey">
                                    <td>Permanent Residential Address</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.permanentAddress?.address1 ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.permanentAddress?.address1.slice(0, 5) + "******************"  : ""}`) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>Country</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                      "country",
                                      allJourneyData.lifeAssuredDetails?.communicationDetails?.permanentAddress?.country
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>Pin code</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {allJourneyData.lifeAssuredDetails?.communicationDetails?.permanentAddress?.pinCode || "NA"} </td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>State</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup(
                                      "state",
                                      allJourneyData.lifeAssuredDetails?.communicationDetails?.permanentAddress?.state
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>City</td>
                                    <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(allJourneyData.lifeAssuredDetails?.communicationDetails?.permanentAddress?.cityDistrict) || "NA"} </td>
                                  </tr>

                                </>
                                :
                                <tr className="table-color-grey">
                                  <td>Permanent Residential Address</td>
                                  <td align="right" style={{ wordBreak: "break-all" }}> {"Same As Current Address"} </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Insurance Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              {allJourneyData.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.map((insurance, index) => {
                                return (
                                  <>
                                    <tr className="table-color-grey">
                                      <td>Name of Insurance Company </td>
                                      <td align="right"> {lineCapital(insurance?.insuranceCompany)} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>Sum Assured</td>
                                      <td align="right"> {insurance?.sumAssured}</td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>Status </td>
                                      <td align="right"> {insurance?.currentStatus ? lineCapital(getValueFromLookup(
                                        "insuranceStatus",
                                        insurance?.currentStatus
                                      )) : "NA"} </td>
                                    </tr>
                                  </>
                                )
                              })}
                              <tr className="table-color">
                                <td> Do you have an E-IA</td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.amlAddendum?.eInsurance?.haveEIA
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Please Select Repository</td>
                                <td align="right">{lineCapital(getValueFromLookup(
                                  "insuranceRepository",
                                  allJourneyData.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  Have any of your Life/ Health insurance
                                  proposal(s) been declined / postponed / dropped
                                  or accepted with modified terms?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.preInsuranceDetails?.prevProposalDeclinedInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Do You need a physical copy of Policy Document?</td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.amlAddendum?.eInsurance?.physicalCopy
                                )) || "NA"} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Risk Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color-grey">
                                <td>
                                  Has more than one of your close relatives
                                  (father, mother, brother(s), sister(s) died
                                  before the age of 60 years as a result of heart
                                  attack, stroke, cancer, diabetes, blood
                                  pressure, kidney disease or any hereditary
                                  disorder?)
                                </td>
                                <td align="right"> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalInfo?.hltQn1?.hltQn1Ind
                                )) == "Na" ? "No" : (getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalInfo?.hltQn1?.hltQn1Ind
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  Have you ever been investigated, treated or
                                  diagnosed or intending to seek any medical
                                  advice for any disease / medical symptoms /
                                  accident lasting more than a week or availed
                                  medical leave for more than 5 days?
                                </td>
                                <td align="right"> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails.medicalDetails.healthQuestions.medicalQuestions.subHltQn1.hltQn1iii.hltQn1iiiInd
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Diabetes mellitus, high blood sugar levels or
                                  sugar in urine
                                </td>
                                <td align="right"> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2vii?.hltQn2viiInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  {" "}
                                  High blood pressure/hypertension, chest pain,
                                  heart attack, angina or disorders pertaining to
                                  the heart or circulatory system
                                </td>
                                <td align="right"> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2i?.hltQn2iInd
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Cancer, tumour, growth, cyst, lump of any kind
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2iii?.hltQn2iiiInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  Asthma, tuberculosis, bronchitis, difficulty in
                                  regular breathing, or any other respiratory
                                  disorder
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2v?.hltQn2vInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Any disorder of the stomach (e.g ulcers,
                                  colitis), intestine, liver (including jaundice),
                                  kidney, urinary bladder, prostate or
                                  blood/protein in urine?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2vi?.hltQn2viInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Any disorder of the reproductive system?</td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2viii?.hltQn2viiiInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Any back, Arthritic, Joint or bone disorders?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2ix?.hltQn2ixInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  Any congenital defect, physical
                                  deformity/disability or handicap?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2xi?.hltQn2xiInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Any disorder of the ear, nose, throat or skin?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2iv?.hltQn2ivInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                              <td>
                                  Anaemia or any other blood related disorder?
                                </td>
                                <td align="right">{lineCapital(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2x?.hltQn2xInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Depression, Anxiety or any other mental or
                                  psychiatric disorder?
                                </td>
                                <td align="right">{lineCapital(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2ii?.hltQn2iiInd
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  Any other medical condition, illnesses, surgery
                                  or treatment not mentioned above
                                </td>
                                <td align="right">{lineCapital(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2x?.hltQn2xInd,
                                )) == "Na" ? "No" : lineCapital(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.hltQn2?.hltQn2x?.hltQn2xInd,
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>
                                  Have you or your spouse ever tested positive or
                                  treated for any sexually transmitted disease,
                                  HIV/AIDS, Hepatitis B or C or are you awaiting
                                  results of such tests?
                                </td>
                                 <td align="right">{lineCapital(getValueFromLookup(
                                    "yesNo",
                                    allJourneyData.lifeAssuredDetails.medicalDetails?.healthQuestions?.medicalQuestions?.subHltQn1?.hltQn1v?.hltQn1vInd
    
                                  )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                  During the last 5 years have you had or been
                                  advised to have any investigations like blood
                                  reports / ECG (other than pre-employment or
                                  preventive health checkup) etc, surgery, have
                                  attended or been advised to attend a hospital or
                                  clinic or waiting for any kind of treatment to
                                  start?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.subHltQn1?.hltQn1ii?.hltQn1iiInd
                                )) || "NA"} </td>
                              </tr>
                              {allJourneyData.lifeAssuredDetails?.gender === "F" &&
                                <tr className="table-color-grey">
                                  <td>Are you pregnant?</td>
                                  <td align="right">{(getValueFromLookup(
                                    "yesNo",
                                    allJourneyData.lifeAssuredDetails?.medicalDetails?.femaleLa?.pregnantAtPresent
                                  )) == "Na" ? "No" : (getValueFromLookup(
                                    "yesNo",
                                    allJourneyData.lifeAssuredDetails?.medicalDetails?.femaleLa?.pregnantAtPresent
                                  )) || "NA"} </td>
                                </tr>
                              }
                              {allJourneyData.lifeAssuredDetails?.gender === "F" &&
                                <tr className="table-color">
                                  <td>
                                    Are there any pregnancy related complication or
                                    any other gynaecological disorders?
                                  </td>
                                  <td align="right">{(getValueFromLookup(
                                    "yesNo",
                                    allJourneyData.lifeAssuredDetails?.medicalDetails?.femaleLa?.sufferFromGyneProblem
                                  )) == "Na" ? "No" : (getValueFromLookup(
                                    "yesNo",
                                    allJourneyData.lifeAssuredDetails?.medicalDetails?.femaleLa?.sufferFromGyneProblem
                                  )) || "NA"} </td>
                                </tr>
                              }
                              <tr className="table-color-grey">
                                <td>
                                  Do you take part in hobbies that are risky in
                                  any way? E.g. Aviation, Diving, Mountaineering
                                  etc
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData?.lifeAssuredDetails?.lifeStyleAndHabits?.laTakePartRisk
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>
                                Been hospitalized for general checkup, observation, treatment or surgery?
                                </td>
                                <td align="right">{(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions?.subHltQn1?.hltQn1i?.hltQn1iInd,
                                )) || "NA"} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {
                      appointeeDetails?.fullName &&
                      <div className="col-md-12 pr pl">
                        <div className="table-responsive table-design">
                          <h2 className="headline-table">Appointee Details</h2>
                          <div className="table-bg">
                            <table className="table">
                              <tbody>
                                <tr className="table-color-grey">
                                  <td>Appointee's Full Name</td>
                                  <td align="right"> {lineCapital(appointeeDetails?.fullName) || "NA"} </td>
                                </tr>
                                <tr className="table-color">
                                  <td>Date of Birth</td>
                                  <td align="right"> {getDateInFormat(
                                    appointeeDetails?.dob
                                  ) || "NA"}</td>
                                </tr>
                                <tr className="table-color-grey">
                                  <td>Appointee’s Relationship with Nominee</td>
                                  <td align="right"> {lineCapital(getValueFromLookup(
                                    "appointeeRelationshipWithNominee",
                                    appointeeDetails?.relationshipWithNominee
                                  )) || "NA"} </td>
                                </tr>
                                <tr className="table-color">
                                  <td> Gender</td>
                                  <td align="right"> {lineCapital(getValueFromLookup(
                                    "gender",
                                    appointeeDetails?.gender
                                  )) || "NA"}</td>
                                </tr>
                                <tr className="table-color-grey">
                                  <td>Appointee’s Contact Number</td>
                                  <td align="right">{appointeeDetails?.contactDetails?.mobileNo || "NA"} </td>
                                </tr>
                                <tr className="table-color">
                                  <td>Country</td>
                                  <td align="right">{appointeeDetails?.communicationDetails?.country ?
                                   lineCapital(getValueFromLookup(
                                    "country",
                                    appointeeDetails?.communicationDetails?.country
                                  ))  : "NA"} </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    }
                    {
                      allJourneyData.lifeAssuredDetails.isLaAndPropSame === "N" && (
                    <div>
                     <div className="col-md-12 pr pl">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">Proposer Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr className="table-color">
                                <td> Name </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital( `${allJourneyData?.proposerDetails?.firstName} ${allJourneyData?.proposerDetails?.middleName} ${allJourneyData?.proposerDetails?.lastName}`) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Gender </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "gender",
                                  allJourneyData.proposerDetails?.gender
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Date of Birth </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {maskInFormat(
                                  allJourneyData.proposerDetails?.dob * 1000
                                ) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                              <td>Marital Status</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup("maritalStatus", allJourneyData?.proposerDetails?.maritalStatus)) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Residential Status </td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "residentStatus",
                                  allJourneyData.proposerDetails?.residentStatus
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Proposer’s Relationship with Life to be Insured </td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(getValueFromLookup("proposerRelationshipWithLA", allJourneyData?.proposerDetails?.relationshipWithInsured)) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Country of Residence</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.proposerDetails?.countryOfResidence
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Country of Birth</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(lineCapital(getValueFromLookup(
                                  "country",
                                  allJourneyData.proposerDetails?.countryOfBirth
                                ))) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Citizenship</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "country",
                                  allJourneyData.proposerDetails?.citizenship
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Nationality</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "country",
                                  allJourneyData?.proposerDetails?.nationality
                                )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Tax Residence Country</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{(getValueFromLookup(
                                  "country",
                                  allJourneyData?.proposerDetails?.communicationDetails?.additionalInfo?.taxResidencyCountry
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Annual Income</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails?.employmentDetails?.annualIncome ? allJourneyData?.proposerDetails?.employmentDetails?.annualIncome.slice(0, 5) + "*****" : "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Pan Number</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails?.panNumber ? `******${allJourneyData?.proposerDetails?.panNumber.slice(-4)?.toUpperCase()}` : "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>ID Proof</td>
                                <td align="right"> {lineCapital(getValueFromLookup(
                                        "PROOF_OF_ID",
                                        allJourneyData?.proposerDetails?.proofOfIdentity
                                      )) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Current Address Proof</td>
                                <td align="right"> {lineCapital(getValueFromLookup(
                                        "ADDRESS_PROOF_VERIFIED",
                                        allJourneyData.proposerDetails?.communicationDetails?.currentAddress.addressProof
                                      )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>CKYC Number(if Applicable)</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails?.amlAddendum?.eInsurance?.ckycNumber ? allJourneyData?.proposerDetails?.amlAddendum?.eInsurance?.ckycNumber.slice(0,5) + "*****" : "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Father Name</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.proposerDetails?.fatherFirstName ? allJourneyData?.proposerDetails?.fatherFirstName : ""} ${allJourneyData?.proposerDetails?.fatherMiddleName ? allJourneyData?.proposerDetails?.fatherMiddleName : ""} ${allJourneyData?.proposerDetails?.fatherLastName ? allJourneyData?.proposerDetails?.fatherLastName : ""}`) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Mother Name</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{lineCapital(`${allJourneyData?.proposerDetails?.motherFirstName ? allJourneyData?.proposerDetails?.motherFirstName : ""} ${allJourneyData?.proposerDetails?.motherMiddleName ? allJourneyData?.proposerDetails?.motherMiddleName : ""} ${allJourneyData?.proposerDetails?.motherLastName ? allJourneyData?.proposerDetails?.motherLastName : ""}`) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Are you a Politically Exposed Person (PEP)?</td>
                                <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.proposerDetails?.lifeStyleAndHabits?.proPoliticallyExposedPerson
                                    )) || "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Occupation</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(lineCapital(getValueFromLookup(
                                  "occupation",
                                  allJourneyData.proposerDetails?.employmentDetails?.occupation
                                ))) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Exact nature of duties/occupation</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(lineCapital(getValueFromLookup(
                                  "natureOfOccupation",
                                  allJourneyData.proposerDetails?.employmentDetails?.natureOfOccupation
                                ))) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Are there any risk associated with your occupation? Eg Working with Boiler, Explosives, Chemicals etc</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.proposerDetails?.employmentDetails?.riskAssociationWith
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Specify if you are in money services/lottery/casino/gambling/horse jockey/ NGO/ Trust/ Charity/ Real Estate/ Jewelry/ Scrap Dealer/ Diamond dealer</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(getValueFromLookup(
                                  "yesNo",
                                  allJourneyData.proposerDetails?.lifeStyleAndHabits?.associationWith
                                )) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Name of Employer</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails.employmentDetails.otherEmployerName || "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Nature of industry of the Employer</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {allJourneyData?.proposerDetails?.employmentDetails?.employerIndustry ?(lineCapital(getValueFromLookup(
                                  "natureOfIndustry",
                                  allJourneyData?.proposerDetails?.employmentDetails?.employerIndustry
                                ))) : "NA"} </td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Employer/Organisation Address</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.address1 ? ((`${allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.address1 ? allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.address1 : ""} ${allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.address2 ? allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.address2 : ""} ${allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.areaTalukaTehsil ? allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.areaTalukaTehsil : ""}`)) : "NA"}</td>
                              </tr>
                              <tr className="table-color">
                                <td>Country</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{((getValueFromLookup(
                                  "country",
                                  allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.country
                                ))) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>Pin Code</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.pinCode || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>State</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{((getValueFromLookup(
                                      "state",
                                      allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.state
                                    ))) || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                <td>City</td>
                                <td align="right" style={{ wordBreak: "break-all" }}> {(lineCapital(allJourneyData?.proposerDetails?.communicationDetails?.officeAddress?.cityDistrict)) || "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td>Foreign residence address along with current country name</td>
                                <td align="right" style={{ wordBreak: "break-all" }}>{allJourneyData?.proposerDetails?.questNRI?.addAbroad || "NA"}</td>
                              </tr>
                              <tr className="table-color-grey">
                                      <td>
                                        Have you changed country in past 3 yrs?
                                      </td>
                                      <td align="right"> {(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.changeCountryPast
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>
                                        Do you have any former name?
                                      </td>
                                      <td align="right"> {(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.anyFormerName
                                      )) || "NA"}</td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                        Have you changed nationality?
                                      </td>
                                      <td align="right"> {(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.changedNationality
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>
                                        {" "}
                                        Do you earn any income in India?
                                      </td>
                                      <td align="right"> {(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.isEarnIncome
                                      )) || "NA"}</td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                        Is there any prosecution/legal proceeding initiated in the past or going on against you presently before any judicial forum/ authority in the country of your residence?
                                      </td>
                                      <td align="right">{(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.legalCase
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color">
                                      <td>
                                        Name and address, phone no. of your physician in your country of residence?
                                      </td>
                                      <td align="right">{(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.questNRI?.isNriDetailGiven
                                      )) || "NA"} </td>
                                    </tr>
                                    <tr className="table-color-grey">
                                      <td>
                                      Is your Current Address same as Permanent Address?
                                      </td>
                                      <td align="right">{(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.proposerDetails?.communicationDetails?.sameAsCurrentAddress
                                      )) || "NA"} </td>
                                    </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                      )
                    }
                    {allJourneyData.productDetails?.spouseLaDetails?.wishToSecure === "02" && (
                      <div>
                        <div className="col-md-12 pr pl">
                          <div className="table-responsive table-design">
                            <h2 className="headline-table">Joint Life Questionnaire</h2>
                            <div className="table-bg">
                              <table className="table">
                                <tbody>
                                  <tr className="table-color-grey">
                                    <td>
                                      Are there any risk associated with your occupation? E.g. Working with Boiler, Explosives, Chemicals etc                              </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.employmentDetails?.risksAssociated
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>
                                      Do you have any address or residence in Japan?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.communicationDetails?.additionalInfo?.residenceInJapan
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>
                                      Are you a Politically Exposed Person (PEP)?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.lifeStyleAndHabits?.laPoliticallyExposedPerson
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>
                                      {" "}
                                      Does your nature of work involve any association with Money services businesses*/State run lotteries/Casinos/Gaming activity/Gambling/Horse jockey/Jockey club/Not for profit organization/Trusts/charities/Non Government Organizations/ Organizations involved in promoting social, religious, humanitarian cause/real estate /Jewelry/Precious or Semi Precious stones or scrap dealers?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.personalDetails?.associationWith
                                    )) || "NA"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 pr pl">
                          <div className="table-responsive table-design">
                            <h2 className="headline-table">Joint Life Medical Information </h2>
                            <div className="table-bg">
                              <table className="table">
                                <tbody>
                                  <tr className="table-color-grey">
                                    <td>
                                      Have you consumed tobacco in any form in the last 12 months
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.personalDetails?.smoking
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>
                                      Have you ever been diagnosed with, treated for, or advised to seek treatment for any serious illness, such as (but not limited to) heart disease, diabetes / raised blood sugar, high blood pressure / hypertension, stroke / paralysis, cancer, kidney disease, liver disease, mental illness, or HIV / AIDS?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.medicalDetails?.healthQuestions?.medicalInfo?.subHltQn2?.hltQn2i?.hltQn2iInd
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>
                                      Are you currently receiving medical treatment or taking any medicine or drugs (other than for minor ailments such as the common cold or influenza)?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.medicalDetails?.healthQuestions?.medicalInfo?.subHltQn2?.hltQn2ii?.hltQn2iiInd
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color">
                                    <td>
                                      {" "}
                                      Are you planning, or have you been advised to undergo any medical treatment, surgery or diagnostic / investigative procedure?
                                    </td>
                                    <td align="right"> {(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.medicalDetails?.healthQuestions?.medicalInfo?.subHltQn2?.hltQn2iii?.hltQn2iiiInd
                                    )) || "NA"}</td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>
                                      Have you, during the last 12 months, been absent from work due to illness or injury for a continuous period of more than 10 consecutive days?
                                    </td>
                                    <td align="right">{(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.medicalDetails?.healthQuestions?.medicalInfo?.subHltQn2?.hltQn2iv?.hltQn2ivInd
                                    )) || "NA"} </td>
                                  </tr>
                                  <tr className="table-color-grey">
                                    <td>
                                      Have you ever had an application for life, health or accident insurance on your life declined, postponed, withdrawn or accepted on special terms?
                                    </td>
                                    <td align="right">{(getValueFromLookup(
                                      "yesNo",
                                      allJourneyData.spouseDetails?.preInsuranceDetails?.prevProposalDeclinedInd
                                    )) || "NA"} </td>
                                  </tr>
                                  {allJourneyData.spouseDetails?.gender === "F" &&
                                    <tr className="table-color-grey">
                                      <td>Are you pregnant?</td>
                                      <td align="right">{(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.medicalDetails?.femaleLa?.pregnantAtPresent
                                      )) || "NA"} </td>
                                    </tr>
                                  }
                                  {allJourneyData.spouseDetails?.gender === "F" &&
                                    <tr className="table-color">
                                      <td>
                                        Are there any pregnancy related complication or
                                        any other gynaecological disorders?
                                      </td>
                                      <td align="right">{(getValueFromLookup(
                                        "yesNo",
                                        allJourneyData.spouseDetails?.medicalDetails?.femaleLa?.sufferFromGyneProblem
                                      )) || "NA"} </td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                      </div>
                    )}
                  </div>
                </div>
                <div className="clearfix"></div>
                <div className="iselect-mg-bottom button-application-design hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                      <button
                        type="button"
                        className="provider edit12"
                        aria-hidden="true"
                        tabIndex="0"
                        style={{ borderRadius: "10px" }}
                        onClick={handleEdit}
                      >
                        <a >Edit</a>
                      </button>
                      <div className="provider previous-btn cen review-detail-submit-bt" tabIndex="0" onKeyPress={(e) => handleEnterSubmit(e)}>
                        {" "}
                        <a aria-hidden="true" onClick={handleSubmit} > Submit </a>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          }
        </div>
      </div>
      {/* body Section */}

      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <button
                type="button"
                className="edit12"
                aria-hidden="true"
                style={{ width: "140px", borderRadius: "10px", marginBottom: "0px" }}
                onClick={handleEdit}
              >
                <a >Edit</a>
              </button>
              <div className="previous-btn cen" style={{"marginLeft":"10px"}}>
                {" "}
                <a aria-hidden="true" onClick={handleSubmit} > Submit </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button-->  */}

    </>
  )
}
